import { render, staticRenderFns } from "./OrgCases.vue?vue&type=template&id=3b5250a5&"
import script from "./OrgCases.vue?vue&type=script&lang=js&"
export * from "./OrgCases.vue?vue&type=script&lang=js&"
import style0 from "./OrgCases.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports